<script setup lang="ts">
import { provide, ref, toRef } from "vue";

import { labelInputKey } from "./injectKeys";

const props = defineProps<{ label: string; error?: string }>();

const forId = ref("");
provide(labelInputKey, {
  error: toRef(props, "error"),
  setId: (id: string) => {
    forId.value = id;
  },
});
</script>

<template>
  <div class="label-input">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label :for="forId">{{ label }}</label>
    <slot />
    <div class="error-message" aria-live="polite">{{ error }}</div>
  </div>
</template>

<style lang="scss">
@use "@/styles/font";
@use "@/styles/variables/colors";

.label-input {
  label {
    display: block;
    font-size: 90%;
    font-weight: font.$weight-bold;
    margin-bottom: 0.4em;
  }

  .error-message {
    height: 1em;
    margin-top: 0.4em;
    font-size: 90%;
    color: colors.$destructive;
  }
}
</style>
